import { render, staticRenderFns } from "./flower.vue?vue&type=template&id=37edbf7c"
import script from "./flower.vue?vue&type=script&lang=js"
export * from "./flower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports